/**
 * Takes time in string format (hh:mm)
 * Returns a number of minutes
 */
export function timeInMinutes(time: string): number {
  return Number(time.split(':')[0]) * 60 + Number(time.split(':')[1]);
}
